declare global {
  interface Window {
    ServerTimezone: string;
    UserTimezone: string;
  }
}

export const serverTimezone = window.ServerTimezone;
export const userTimezone = window.UserTimezone;
